module.exports = __webpack_public_path__ + "img/home-hero-image_medium.d9b8d109.jpg";